export default __webpack_public_path__ + "static/media/smarthome.b81b4ac0.png";